import type { ReactNode } from "react";

/**
 * Friendly empty-state block. See design.md §9.
 *
 * Pattern: soft icon → short headline → one-sentence helper → single CTA.
 * Avoid stacking multiple actions; the empty state is for first-time guidance,
 * not a menu.
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
}: {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center rounded-2xl border border-dashed border-slate-300 bg-white px-6 py-12 text-center">
      {icon ? (
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-brand-50 text-brand-700">
          {icon}
        </div>
      ) : null}
      <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
      {description ? (
        <p className="mt-2 max-w-xs text-sm leading-relaxed text-slate-600">{description}</p>
      ) : null}
      {action ? <div className="mt-6 w-full max-w-xs">{action}</div> : null}
    </div>
  );
}
